import React from "react";
import EventListenerSummary from "./EventListenerSummary";
import labels from "../helpers/labels";
import Errors from "../../../Components/Errors";

export default function EventSummary({ state, event, node, engine }) {
  return (
    <div
      className="bg-white p-3 bg-opacity-50 my-1"
      onWheel={(e) => {
        e.stopPropagation();
      }}
    >
      <h3 className="my-0">Event: {labels[event] || event}</h3>
      <Errors
        filterFn={(e) =>
          node.options.id === e.workflow?.UUID && e.EventType === event
        }
      />
      <div>
        {[...(state.EventListeners || [])]
          ?.filter((listener) => listener.EventType === event)
          .sort((a, b) => a.Order - b.Order)
          .map((eventListener) => (
            <EventListenerSummary
              key={eventListener.UUID}
              eventListener={eventListener}
              node={node}
              engine={engine}
            />
          ))}
      </div>
    </div>
  );
}
